import { defineStore } from 'pinia'

export const useCinemaStore = defineStore({
    id: 'cinema',

    state: () => {
        return {
            opened: false,
            playlist: [],
            current: null,
            currentIndex: 0
        }
    },

    actions: {        
        play (index) {
            if (!this.playlist.length) return this.current = null;
    
            let currentIndex = index && this.playlist[index] ? index : 0;
    
            this.currentIndex = currentIndex;
            this.current      = this.playlist[currentIndex]
        },
    
        changeVideo (index) {
            this.currentIndex = index;
        },
    
        on ({playlist, index}) {
            if (!playlist.length) return true;
    
            this.playlist = playlist;
            this.play(index);
            this.opened = true;
        },
    
        off () {
            this.opened = false;
            this.playlist = [];
            this.play(null);
        }
    }
});
